import { useEffect, useState, type RefObject } from 'react';
import { NavigationType, useLocation, useNavigationType } from 'react-router';

// Navigation state of an in-panel move into a space: selector, side menu or the landing redirect.
export const ARRIVAL_STATE = { arrival: true } as const;

export function isArrivalState(state: unknown): boolean {
  return typeof state === 'object' && state !== null && 'arrival' in state && state.arrival === true;
}

// Cold loads, reloads and Back/Forward are POP and replay the entry's state; only PUSH/REPLACE counts.
export function useIsArrival(): boolean {
  const state: unknown = useLocation().state;
  const navigationType = useNavigationType();
  const [arrived] = useState(() => navigationType !== NavigationType.Pop && isArrivalState(state));
  return arrived;
}

export function useArrivalFocus(target: RefObject<HTMLElement | null>): void {
  const arrived = useIsArrival();
  useEffect(() => {
    if (arrived) target.current?.focus();
  }, [arrived, target]);
}
